export const localStorageService = {
  getItem<ValueType>(key: string): ValueType | null {
    try {
      const item = localStorage.getItem(key)
      return item ? (JSON.parse(item) as ValueType) : null
    } catch {
      return null
    }
  },
  setItem<ValueType>(key: string, value: ValueType): void {
    try {
      const item = JSON.stringify(value)
      localStorage.setItem(key, item)
    } catch {
      return
    }
  },
  removeItem(key: string): void {
    localStorage.removeItem(key)
  },
  clear(): void {
    localStorage.clear()
  },
  composeKey(...parts: string[]): string {
    return parts.join('_')
  },
}
